export interface ApiPlatformCollection<T> {
  members: T[];
  totalItems: number;
  raw: any;
}

export const normalizeApiPlatformCollection = <T>(raw: any): ApiPlatformCollection<T> => {
  const members = Array.isArray(raw)
    ? raw
    : raw?.member || raw?.['hydra:member'] || raw?.items || [];
  const totalItems = raw?.totalItems || raw?.['hydra:totalItems'] || members.length;

  return {
    members: Array.isArray(members) ? members : [],
    totalItems: typeof totalItems === 'number' ? totalItems : members.length,
    raw
  };
};
